import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, BarChart, Bar } from 'recharts';
import { Card, CardContent, CardHeader } from './ui/Card';
const growthData = [{
  year: '2019',
  portfolio: 100000,
  benchmark: 100000
}, {
  year: '2020',
  portfolio: 115000,
  benchmark: 108000
}, {
  year: '2021',
  portfolio: 138000,
  benchmark: 118000
}, {
  year: '2022',
  portfolio: 142000,
  benchmark: 112000
}, {
  year: '2023',
  portfolio: 168000,
  benchmark: 128000
}, {
  year: '2024',
  portfolio: 195000,
  benchmark: 142000
}, {
  year: '2025',
  portfolio: 224000,
  benchmark: 156000
}];
const allocationData = [{
  name: 'Equities',
  value: 65
}, {
  name: 'Bonds',
  value: 20
}, {
  name: 'Real Estate',
  value: 10
}, {
  name: 'Cash',
  value: 5
}];
export function TrustMetrics() {
  return <section className="py-24 bg-slate-50" data-id="element-84">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-85">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-86">
          <h2 className="text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-4" data-id="element-87">
            Proven Performance
          </h2>
          <p className="text-lg text-slate-600" data-id="element-88">
            Our strategies are designed to outperform standard benchmarks while
            minimizing volatility.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-89">
          {/* Growth Chart */}
          <Card className="shadow-lg border-none" data-id="element-90">
            <CardHeader data-id="element-91">
              <h3 className="text-lg font-semibold text-slate-900" data-id="element-92">
                Cumulative Growth (PLN)
              </h3>
              <p className="text-sm text-slate-500" data-id="element-93">
                Powerquest Strategy vs. Standard Benchmark
              </p>
            </CardHeader>
            <CardContent data-id="element-94">
              <div className="h-[300px] w-full" data-id="element-95">
                <ResponsiveContainer width="100%" height="100%" data-id="element-96">
                  <AreaChart data={growthData} margin={{
                  top: 10,
                  right: 10,
                  left: 0,
                  bottom: 0
                }} data-id="element-97">
                    <defs data-id="element-98">
                      <linearGradient id="colorPortfolio" x1="0" y1="0" x2="0" y2="1" data-id="element-99">
                        <stop offset="5%" stopColor="#1e3a8a" stopOpacity={0.3} data-id="element-100" />
                        <stop offset="95%" stopColor="#1e3a8a" stopOpacity={0} data-id="element-101" />
                      </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#e2e8f0" data-id="element-102" />
                    <XAxis dataKey="year" axisLine={false} tickLine={false} tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} dy={10} data-id="element-103" />
                    <YAxis axisLine={false} tickLine={false} tick={{
                    fill: '#64748b',
                    fontSize: 12
                  }} tickFormatter={value => `${value / 1000}k`} data-id="element-104" />
                    <Tooltip contentStyle={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0',
                    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
                  }} formatter={(value: number) => [`${value.toLocaleString()} PLN`, '']} data-id="element-105" />
                    <Area type="monotone" dataKey="portfolio" stroke="#1e3a8a" strokeWidth={3} fillOpacity={1} fill="url(#colorPortfolio)" name="Powerquest" data-id="element-106" />
                    <Area type="monotone" dataKey="benchmark" stroke="#94a3b8" strokeWidth={2} strokeDasharray="5 5" fill="transparent" name="Benchmark" data-id="element-107" />
                  </AreaChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>

          {/* Allocation Chart */}
          <Card className="shadow-lg border-none" data-id="element-108">
            <CardHeader data-id="element-109">
              <h3 className="text-lg font-semibold text-slate-900" data-id="element-110">
                Strategic Asset Allocation
              </h3>
              <p className="text-sm text-slate-500" data-id="element-111">
                Diversification across uncorrelated asset classes
              </p>
            </CardHeader>
            <CardContent data-id="element-112">
              <div className="h-[300px] w-full" data-id="element-113">
                <ResponsiveContainer width="100%" height="100%" data-id="element-114">
                  <BarChart data={allocationData} layout="vertical" margin={{
                  top: 10,
                  right: 30,
                  left: 40,
                  bottom: 0
                }} data-id="element-115">
                    <CartesianGrid strokeDasharray="3 3" horizontal={true} vertical={false} stroke="#e2e8f0" data-id="element-116" />
                    <XAxis type="number" hide data-id="element-117" />
                    <YAxis dataKey="name" type="category" axisLine={false} tickLine={false} tick={{
                    fill: '#1e293b',
                    fontSize: 14,
                    fontWeight: 500
                  }} width={100} data-id="element-118" />
                    <Tooltip cursor={{
                    fill: '#f1f5f9'
                  }} contentStyle={{
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    border: '1px solid #e2e8f0'
                  }} data-id="element-119" />
                    <Bar dataKey="value" fill="#1e3a8a" radius={[0, 4, 4, 0]} barSize={32} data-id="element-120" />
                  </BarChart>
                </ResponsiveContainer>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>;
}